module.exports = __webpack_public_path__ + "img/59_3.c521c6b3.png";